import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';

import type { TrendReport } from '../types';
import { DISPLAY_FONT, SECTION_HEADING_SX, TREND_COLORS } from '../trendTheme';

type TrendReportDetailDialogProps = {
  report: TrendReport | null;
  open: boolean;
  onClose: () => void;
};

export default function TrendReportDetailDialog({ report, open, onClose }: TrendReportDetailDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ fontFamily: DISPLAY_FONT, color: TREND_COLORS.navy }}>
        {report?.title || 'Trendrapport'}
      </DialogTitle>
      <DialogContent dividers>
        {report && (
          <Stack spacing={3}>
            <Stack spacing={0.5}>
              <Typography variant="body2" sx={{ color: TREND_COLORS.textMuted }}>
                {report.issueDate?.slice(0, 10)} • {report.status}
              </Typography>
              <Typography variant="body1" sx={{ color: TREND_COLORS.textPrimary, lineHeight: 1.7 }}>
                {report.intro || 'Ingen introduktion finns ännu.'}
              </Typography>
            </Stack>

            <Stack spacing={1}>
              <Typography sx={SECTION_HEADING_SX}>Redaktionell sammanfattning</Typography>
              <Typography variant="body1" sx={{ color: TREND_COLORS.textSecondary, lineHeight: 1.7 }}>
                {report.editorSummary || 'Ingen redaktionell sammanfattning tillagd ännu.'}
              </Typography>
            </Stack>

            <Stack spacing={1}>
              <Typography sx={SECTION_HEADING_SX}>Vad betyder detta för Fontana?</Typography>
              <Typography variant="body1" sx={{ color: TREND_COLORS.textSecondary, lineHeight: 1.7 }}>
                {report.whatItMeansForUs || 'Ingen verksamhetstolkning finns ännu.'}
              </Typography>
            </Stack>

            <Stack spacing={1}>
              <Typography sx={SECTION_HEADING_SX}>Highlights</Typography>
              {report.highlights.length > 0 ? (
                report.highlights.map((highlight) => (
                  <Typography key={highlight} variant="body2" sx={{ color: TREND_COLORS.textSecondary, lineHeight: 1.6 }}>
                    • {highlight}
                  </Typography>
                ))
              ) : (
                <Typography variant="body2" sx={{ color: TREND_COLORS.textMuted }}>
                  Inga highlights tillagda ännu.
                </Typography>
              )}
            </Stack>
          </Stack>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} sx={{ color: TREND_COLORS.navy }}>Stäng</Button>
      </DialogActions>
    </Dialog>
  );
}
